import { CommonHelperFunctions, EDesignerEntityKind, IEntityModificationDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";

const backendUrl: string = CommonHelperFunctions.GetBackendUrl();

export class EntityModificationService {
  /**
   * When each of the given kinds of asset last changed, and by whom.
   *
   * `projectId` is required unless every requested kind is workspace-level (domain
   * configurations, and the datasources and actions a project inherits).
   *
   * Unlike the rest of the services here this one does NOT route a failure through
   * `KMainFunctions.exceptionHandler`: the feed decorates a list the user can already read, so a
   * slow or broken call must colour a column, not raise a dialog over a working page. It answers
   * null instead, and the caller shows the list undated.
   */
  public static async GetModifications(
    kinds: EDesignerEntityKind[],
    projectId?: string
  ): Promise<IEntityModificationDto[] | null> {
    if (kinds.length === 0) return [];

    const params: URLSearchParams = new URLSearchParams();
    kinds.forEach((kind: EDesignerEntityKind) => params.append("kinds", String(kind)));
    if (projectId) params.append("projectId", projectId);

    try {
      const response: AxiosResponse<IEntityModificationDto[]> = await Axios.get<
        null,
        AxiosResponse<IEntityModificationDto[]>
      >(`${backendUrl}/entityModifications?${params.toString()}`);
      return response.data ?? [];
    } catch {
      return null;
    }
  }
}
